import { axiosInstance } from "../../axiosConfig";

export default async function getRecCopies(cartIds: string[]) {
  try {
    const res = await axiosInstance.post(
      "/get_copies/Form",
      {
        history_id_array: cartIds,
        copy_type: "recipient copy",
      },
      {
        responseType: "blob",
      }
    );
    return { data: res.data, header: res.headers };
  } catch (err) {
    throw err;
  }
}
